var _defs, _path, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuisson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_9",
    "data-name": "Calque 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 427.12 431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#965d36;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#3e7f13;}.cls-5{fill:#559914;}.cls-6{clip-path:url(#clip-path-2);}.cls-7{clip-path:url(#clip-path-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-493 -1738)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 782.5,
    cy: 2004,
    r: 104
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-493 -1738)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 666.5,
    cy: 1939.5,
    r: 148.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-493 -1738)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 561.5,
    cy: 2028.5,
    r: 68.5
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "buisson") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M666,2169s-87-53-115-132c53,51,71,79,93,86s-50-87-35-97,57,84,57,84,36-83,46-84-43,97-31,102,93-78,101-67S666,2169,666,2169Z",
    transform: "translate(-493 -1738)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 289.5,
    cy: 266,
    r: 104
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 309.81,
    cy: 228.88,
    rx: 117.31,
    ry: 104
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.5,
    cy: 201.5,
    r: 148.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 202.5,
    cy: 148.5,
    rx: 167.5,
    ry: 148.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 68.5,
    cy: 290.5,
    r: 68.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 81.88,
    cy: 266.05,
    rx: 77.26,
    ry: 68.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuisson);
export default __webpack_public_path__ + "static/media/buisson.903acc22aec2397e5f47fc685b112c0b.svg";
export { ForwardRef as ReactComponent };